export default __webpack_public_path__ + "static/media/logo-color.b66357b6.svg";